import _ from 'lodash'

class ApiProgressClass {
    _loading( form ) {
        _.addClass( form, 'is--loading' )
    }
    _loaded( form ) {
        _.removeClass( form, 'is--loading' )
    }
}

const API_PROGRESS = new ApiProgressClass()
export default API_PROGRESS